/* eslint-disable @typescript-eslint/no-explicit-any */
import { Notifier } from "@airbrake/browser";

export const airbrake = new Notifier({
  projectId: 630737,
  projectKey: "2ae12b2d64f22c61d301564e25b734a7",
  environment: "production",
});

export const airbrakeNotify = (event: any) => {
  if (process.env.NODE_ENV === "production") {
    airbrake.notify(event);
  }
};
